// components/DealStageSelector.js
// Dropdown + RAG preview for selecting a deal's current stage template.
// Used inside DealEditPage.

import React, { useState, useEffect } from 'react';

const token = () => localStorage.getItem('token');

const RAG_DOT = { red: '#ef4444', amber: '#f59e0b', green: '#10b981' };

export default function DealStageSelector({ value, onChange, disabled = false }) {
  const [stages, setStages]   = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/api/stages', { headers: { Authorization: `Bearer ${token()}` } })
      .then(r => r.json())
      .then(d => setStages(d.stages || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const selected = stages.find(s => s.id === value);

  if (loading) return <div style={{ fontSize: 13, color: '#718096', padding: '10px 0' }}>Loading stages…</div>;

  if (stages.length === 0) {
    return (
      <div style={{ fontSize: 13, color: '#718096', padding: '10px 14px', border: '1px solid #E2E8F0', borderRadius: 8, background: '#f7fafc' }}>
        No stages defined yet.{' '}
        <a href="/stages" style={{ color: '#10b981', textDecoration: 'underline' }}>Set up your stages →</a>
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
      <div style={{ position: 'relative', flex: 1 }}>
        <select
          value={value || ''}
          onChange={e => onChange(e.target.value || null)}
          disabled={disabled}
          style={{
            width: '100%', border: '1px solid #CBD5E0', borderRadius: 8,
            padding: '10px 14px', fontSize: 14, outline: 'none',
            background: '#fff', cursor: disabled ? 'not-allowed' : 'pointer',
            appearance: 'none', fontFamily: 'inherit',
          }}
        >
          <option value="">— No stage assigned —</option>
          {stages.map(s => (
            <option key={s.id} value={s.id}>{s.name} ({s.rag_colour})</option>
          ))}
        </select>
        {/* Dropdown arrow */}
        <span style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none', color: '#718096', fontSize: 12 }}>▼</span>
      </div>

      {/* Live RAG preview */}
      {selected && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexShrink: 0 }}>
          <span style={{
            width: 12, height: 12, borderRadius: '50%',
            background: RAG_DOT[selected.rag_colour] || '#f59e0b',
          }} />
          <span style={{ fontSize: 12, color: '#4a5568', fontWeight: 500 }}>
            {selected.rag_colour.charAt(0).toUpperCase() + selected.rag_colour.slice(1)}
          </span>
        </div>
      )}
    </div>
  );
}
